import { InvoiceNumberingMode } from '../enums/invoiceNumberingMode'

export const shouldShowNextInvoiceNoField = (invoiceNumberingMode?: string) =>
  invoiceNumberingMode === InvoiceNumberingMode.Sequential
